<ape-admin-page-container
  class="w-full h-full flex flex-col self-stretch flex-1"
  [title]="TRANSLATION_KEYS.admin.monitoring.PLACEHOLDER_TITLE | translate"
  [showBackButton]="true"
  [subtitleOnBottom]="true"
  (backClick)="backClick.emit()"
>
  <ng-template #subtitle>
    <div class="flex justify-start items-center gap-2">
      <span class="text-base font-normal text-black">
        {{TRANSLATION_KEYS.admin.monitoring.details.SUBTITLE | translate}} <b>{{processName}}.</b>
      </span>
    </div>
  </ng-template>

  <!-- KPI -->
  <monitoring-goal-setting-details-counters-template
    *ngIf="!loading"
    [countersCardData]="countersCardData"
  />

  <!-- Toolbar: solleciti + export + search + filtri -->
  <div class="flex flex-row flex-wrap lg:flex-nowrap sm:gap-6 items-start sm:items-center gap-4 w-full">

    <ape-button
      class="w-full sm:w-auto"
      cssClass="!py-2.5 !px-3 !rounded-[4px] w-full !w-full !bg-white sm:whitespace-nowrap whitespace-normal"
      [label]="TRANSLATION_KEYS.admin.goalSettingMonitoring.SOLICIT_DEFINITIONS | translate"
      [variant]="'primary'"
      [aspect]="'icon-outline'"
      [size]="'regular'"
      [rounded]="false"
      leftIcon="assets/icons/mail.svg"
      (buttonClick)="solicitDefinitionsClicked.emit()"
    />

    <ape-button
      class="w-full sm:w-auto"
      cssClass="!py-2.5 !px-3 !rounded-[4px] w-full !w-full !bg-white sm:whitespace-nowrap whitespace-normal"
      [label]="TRANSLATION_KEYS.admin.goalSettingMonitoring.SOLICIT_PROPOSALS | translate"
      [variant]="'primary'"
      [aspect]="'icon-outline'"
      [size]="'regular'"
      [rounded]="false"
      leftIcon="assets/icons/mail.svg"
      (buttonClick)="solicitProposalsClicked.emit()"
    />

    <!--
    non richiesto per ora in analisi, per ora commentiamo
    <ape-button
      class="w-full sm:w-auto"
      cssClass="!py-2.5 !px-3 !rounded-[4px] w-full !w-full !bg-white sm:whitespace-nowrap whitespace-normal"
      [label]="TRANSLATION_KEYS.admin.goalSettingMonitoring.SOLICIT_UPDATES | translate"
      [variant]="'primary'"
      [aspect]="'icon-outline'"
      [size]="'regular'"
      [rounded]="false"
      leftIcon="assets/icons/mail.svg"
      (buttonClick)="solicitUpdatesClicked.emit()"
    />-->

    <ape-download-button
      [iconSrc]="'assets/icons/xls.svg'"
      [downloadId]="'monitoring-goal-setting-report-download'"
      (downloadClick)="exportXlsClicked.emit($event)"
    />

    <div class="flex flex-row items-center !w-full sm:w-auto sm:min-w-[200px]">
      <ape-input
        [cssClassInputWrapper]="'!w-full'"
        class="!w-full"
        [showLabelText]="false"
        [cssClass]="'!h-[46px] !w-full'"
        [value]="searchedText"
        (valueChange)="searchChange.emit($event)"
        (onKeyUp)="searchUsers.emit()"
        [placeholder]="TRANSLATION_KEYS.admin.goalSettingMonitoring.SEARCH_PLACEHOLDER | translate"
      />
      <div
        tabindex="0"
        role="button"
        (click)="searchUsers.emit()"
        class="rounded-[0px_3px_3px_0px] h-[46px] w-[46px] text-base font-medium bg-black text-white p-[11px] flex flex-row items-center flex-shrink-0 cursor-pointer"
      >
        <svg-icon
          name="search"
          class="w-[24px] h-[24px]"
          src="assets/icons/search.svg"
          [attr.aria-hidden]="true"
        />
      </div>
    </div>
    <ape-button
      class="w-full sm:w-auto"
      (buttonClick)="advancedFiltersClicked.emit()"
      cssClass="!py-2.5 !px-3 !rounded-[4px] !bg-black w-full !w-full whitespace-nowrap flex-shrink-0"
      [label]="TRANSLATION_KEYS.admin.monitoring.ADVANCED_FILTERS | translate"
      [variant]="'primary'"
      [aspect]="'icon'"
      [size]="'regular'"
      [rounded]="false"
      leftIcon="assets/icons/funnel.svg"
    />
  </div>

  <!-- Chip filtri applicati -->
  <div
    *ngIf="appliedChips.length > 0"
    class="w-full flex flex-row items-center"
  >
    <div class="flex flex-row flex-wrap gap-[10px] max-md:flex-nowrap overflow-x-auto">
      <ape-status-badge
        [withCloseIcon]="true"
        *ngFor="let chip of appliedChips; trackBy: trackChip"
        [aspect]="'filter'"
        [kind]="'active-filter'"
        [label]="chip.label"
        [clickable]="true"
        (onCloseBadge)="removeFilterChip.emit(chip)"
      />
    </div>
  </div>

  <div class="w-full h-[1px] bg-[#EEEEEE] mt-[-22px]"></div>

  <!-- Contatore filtri attivi / risultati + sort -->
  <div
    class="w-full flex flex-col sm:flex-row sm:justify-between items-start sm:items-center gap-4 sm:gap-6 mt-[-32px]">
    <div class="flex flex-row items-center flex-wrap gap-2">
      <p class="text-base font-bold text-[var(--colors-gray-scale-black)]">{{ activeFiltersCount }}</p>
      <p class="text-base font-light text-[var(--colors-gray-scale-black)]">
        {{ activeFiltersCount === 1
        ? (TRANSLATION_KEYS.admin.monitoring.ACTIVE_FILTER | translate)
        : (TRANSLATION_KEYS.admin.monitoring.ACTIVE_FILTERS | translate) }}
      </p>
      <p class="text-base font-bold text-[var(--colors-gray-scale-black)]">
        {{ usersDataCount }}
      </p>
      <p class="text-base font-light text-[var(--colors-gray-scale-black)]">
        {{ usersDataCount === 1
        ? (TRANSLATION_KEYS.admin.monitoring.RESULT | translate)
        : (TRANSLATION_KEYS.admin.monitoring.RESULTS | translate) }}
      </p>
    </div>
    <div class="flex flex-row items-center w-full sm:w-auto">
      <ape-select
        class="!w-full sm:!w-auto"
        [isOrderSelect]="true"
        [placeholder]="''"
        [options]="sortOptions"
        [selectedOption]="selectedSortOption"
        optionLabel="label"
        optionValue="id"
        (selectedOptionChange)="sortChange.emit($event)"
      />
    </div>
  </div>

  <div class="w-full h-[1px] bg-[#EEEEEE] mt-[-12px]"></div>

  <!-- Tabella utenti -->
  <ape-admin-monitoring-goal-setting-users-table
    class="mt-[-32px]"
    [usersData]="usersData"
    (impersonateUser)="impersonateUser.emit($event)"
    (impersonateManager)="impersonateManager.emit($event)"
    (downloadPdf)="downloadPdf.emit($event)"
    (solicitManager)="solicitManager.emit($event)"
    (solicitUser)="solicitUser.emit($event)"
    *ngIf="usersData.length > 0 && !loadingUsers && !loadingUsersCount && !loading"
  />

  <!-- Paginazione -->
  <ape-table-pagination
    [total]="totalPages"
    [page]="page"
    [pageSize]="pageSize"
    (pageChange)="pageChange.emit($event)"
    (pageSizeChange)="pageSizeChange.emit($event)"
    *ngIf="usersData.length > 0 && !loadingUsers && !loadingUsersCount && !loading"
  />

  <!-- Placeholder pagina vuota -->
  <ape-page-placeholder
    *ngIf="!loading && usersData.length === 0 && !loadingUsers && !loadingUsersCount"
    [title]="TRANSLATION_KEYS.admin.monitoring.AT_MOMENT | translate"
    [subtitle]="TRANSLATION_KEYS.admin.monitoring.NO_PERSON_INCLUDED | translate"
    [description]="TRANSLATION_KEYS.admin.monitoring.THERE_ARE_NOT_PERSONS_INCLUSED_ON_PROCESS | translate"
  />

  <ape-process-setup-skeleton *ngIf="loading || loadingUsers || loadingUsersCount" />
</ape-admin-page-container>

<!-- Drawer filtri -->
<ape-monitoring-goal-setting-details-filter-drawer
  [visible]="drawerVisible"
  [title]="TRANSLATION_KEYS.admin.goalSettingMonitoring.ADVANCED_FILTERS | translate"
  [activeFiltersCount]="activeFiltersCount"
  [cardStatusOptions]="cardStatusOptions"
  [proposalStatusOptions]="proposalStatusOptions"
  [updatesOptions]="updatesOptions"
  [scorecardTypeOptions]="scorecardTypeOptions"
  [managerOptions]="managerOptions"
  [departmentOptions]="departmentOptions"
  [selectedCardStatuses]="selectedCardStatuses"
  [selectedProposalStatuses]="selectedProposalStatuses"
  [selectedUpdates]="selectedUpdates"
  [selectedScorecardTypes]="selectedScorecardTypes"
  [selectedManagers]="selectedManagers"
  [selectedDepartments]="selectedDepartments"
  [confirmLabel]="TRANSLATION_KEYS.admin.goalSettingMonitoring.APPLY_FILTERS"
  (cardStatusesChange)="cardStatusesChange.emit($event)"
  (proposalStatusesChange)="proposalStatusesChange.emit($event)"
  (updatesChange)="updatesChange.emit($event)"
  (scorecardTypesChange)="scorecardTypesChange.emit($event)"
  (managersChange)="managersChange.emit($event)"
  (departmentsChange)="departmentsChange.emit($event)"
  (onCancel)="closeDrawer.emit()"
  (onConfirm)="applyFilters.emit()"
  (onResetFilters)="resetFilters.emit()"
/>